<template>


  <CDropdown  @drop="readNotifications(items)"
          inNav
          class="c-header-nav-items"
          placement="bottom-end"
          add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-bell"/>
      </CHeaderNavLink>
    </template>
    <!--    <CDropdownHeader tag="div" class="text-center" color="light">-->
    <!--      <strong>ااعلان ها</strong>-->
    <!--    </CDropdownHeader>-->

    <CDropdownItem v-if="!item.is_read"  v-for="(item, itemIndex) in items" :key="itemIndex"
    @click="readNotification(item.id)" style="text-align: right">
      <small>{{item.data.messaage}}</small>
    </CDropdownItem>

<!--    <CDropdownDivider/>-->

<!--    <CDropdownItem  @click="logout">-->
<!--      <CIcon name="cil-lock-locked" /> خروج-->
<!--    </CDropdownItem>-->
  </CDropdown>


</template>


<script>
    import axios from 'axios';

    export default {

        name: 'TheHeaderNotifications',

        data() {

            return {

              auth: {
                headers: {
                  Authorization: 'bearer ' + localStorage.getItem('token'),
                  'Accept-Language': 'fa'
                }
              },

                tokenSet: false,

                userData: {
                    email: "",
                    password: ""
                },

              first_name: "",
              last_name: "",
              email: "",
              avatar: "",
              state: "",
              itemsCount: 42,


              items:[]




            }
        },


        mounted() {


          // this.getNotifications()



        },



        methods: {

          getNotifications(){
            var app = this;
            axios.get('/api/notifications', app.auth)
                    .then(response => {
                      app.items = response.data.data;

                    })
                    .catch(error => {
                      console.log(error);
                      console.log(error.response.status);

                      if (error.response.status === 401)
                        app.logout()
                      // app.$snotify.warning(' خطا رخ داده است');
                    })
          },

          pluck(array, key) {
            return array.map(function (obj) {
              return obj[key];
            });
          },

          readNotification(id){

          },

          readNotifications(items){

          },


        }
    }


</script>






<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>